/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

// Rudra Coresoft colors sampled from website: primary (#4e2e80), secondary (#ff7a59)
export const bhairavaTheme = {
  name: 'bhairava',
  primary: '#000',        // Purple
  secondary: '#7c3aed',      // Light purple
  sidebar: '#7c3aed',
  primaryLight: '#666362',       // Same as primary
  text: '#000',
  footer: '#f3f4f6',
  buttonRadius: '0.5rem', // or your preferred value
  cardRadius: '0.5rem', // Radius for all cards in Application
  gradientBackground: `linear-gradient(90deg, #000, #7c3aed)`
};

export const rudraTheme = {
  name: 'rudra',
  primary: '#4e2e80',        // Rudra CoreSoft-like purple
  secondary: '#ff7a59',      // Rudra orange
  sidebar: '#4e2e80',
  primaryLight: '#8569b0',
  text: '#4e2e80',
  footer: '#f3f4f6',
  buttonRadius: '0.5rem', // or your preferred value
  cardRadius: '0.5rem', // Radius for all cards in Application
  gradientBackground: `linear-gradient(90deg, #4e2e80, #ff7a59)`,
};

// Neelkanth: Deep, mystical blue representing the poison held in the throat.
export const neelkanthTheme = {
  name: 'neelkanth',
  primary: '#1a237e',       // Deep Indigo
  secondary: '#7986cb',     // Lighter Indigo for contrast
  sidebar: '#283593',       // Dark Indigo
  primaryLight: '#5c6bc0',
  text: '#1a237e',
  footer: '#e8eaf6',
  buttonRadius: '0.6rem',
  cardRadius: '0.6rem',
  gradientBackground: `linear-gradient(135deg, #1a237e, #7986cb)`,
};

// Mahakala: Dark, fierce red/maroon representing Time/Destroyer aspect.
export const mahakalaTheme = {
  name: 'mahakala',
  primary: '#880e4f',       // Deep Pink/Maroon
  secondary: '#ff4081',     // Pink Accent for contrast
  sidebar: '#880e4f',
  primaryLight: '#e91e63',
  text: '#880e4f',
  footer: '#fce4ec',
  buttonRadius: '0.2rem',   // Sharper corners for a fierce look
  cardRadius: '0.3rem',
  gradientBackground: `linear-gradient(135deg, #880e4f, #ff4081)`,
};

// Gangadhar: Teal/Cyan representing the Ganges flowing from his hair.
export const gangadharTheme = {
  name: 'gangadhar',
  primary: '#006064',       // Cyan 900
  secondary: '#4dd0e1',     // Cyan 300 for contrast
  sidebar: '#006064',
  primaryLight: '#00acc1',
  text: '#006064',
  footer: '#e0f7fa',
  buttonRadius: '0.8rem',   // Rounder, fluid
  cardRadius: '0.8rem',
  gradientBackground: `linear-gradient(135deg, #006064, #4dd0e1)`,
};

// Nataraja: Fiery orange/red representing the cosmic dance and fire.
export const natarajaTheme = {
  name: 'nataraja',
  primary: '#bf360c',       // Deep Orange 900
  secondary: '#ff8a65',     // Deep Orange 300 for contrast
  sidebar: '#bf360c',
  primaryLight: '#f4511e',
  text: '#bf360c',
  footer: '#fbe9e7',
  buttonRadius: '0.5rem',
  cardRadius: '0.5rem',
  gradientBackground: `linear-gradient(135deg, #bf360c, #ff8a65)`,
};
